<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">

            <article class="title-section header-title input-section form-section ax-app-header-section">
              <div class="w-100">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <p v-if="rxApplication.customer.state == 'NY' || rxApplication.customer.state == 'CT' || rxApplication.customer.state == 'MA' || rxApplication.customer.state == 'AK'"
                       class="font-weight-bold mb-0">Accelerant Specialty Insurance Company</p>
                    <p v-else
                       class="font-weight-bold mb-0">Accelerant National Insurance Company</p>
                  </div>
                </div>
              </div>
              <h1 class="form-title text-center mr-0 ml-0">
                Real Estate Professionals<br>
                Errors and Omissions Insurance Application<br>
                No Known Losses or Circumstances Statement
              </h1>
            </article>

            <article class="input-section form-section">
              <div class="pt-0" >
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Name:
                    </label>
                    <input
                        type="text"
                        name="firmName"
                        :value="rxApplication.applicantFirmName"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmName')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmName') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Firm Address:
                    </label>
                    <input
                        type="text"
                        name="firmAddress"
                        :value="rxApplication.customer.address"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmAddress')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmAddress') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                        type="text"
                        name="firmCity"
                        v-model="rxApplication.customer.city"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmCity')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmCity') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <input
                        type="text"
                        name="firmState"
                        :value="states[rxApplication.customer.state]"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmState')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmState') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      Zip:
                    </label>
                    <input
                        type="text"
                        name="firmZipCode"
                        :value="rxApplication.customer.zipCode"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        disabled
                    >
                    <span
                        v-show="errors.has('firmZipCode')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('firmZipCode') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <h4 class="inputs-table-title  pt-0 mb-0" style="text-align: center;">
                CERTIFICATION OF NO KNOWN AND UNREPORTED CLAIMS OR INCIDENTS
              </h4>
              <div >
                <p class="mb-3">
                  I, the undersigned, certify that I have no knowledge of any claims, legal or otherwise, which have been, or
                  may be made, against any entity or individual for which insurance is requested, which has not been
                  reported previously to you or another insurance company. In addition, after making reasonable inquiries, I
                  am not aware of any act, error or omission, or allegations of any act, error or omissions, or any other
                  circumstances or incidents which could give rise to a claim as a result of the firm’s operations or any
                  individual’s activities on behalf of the firm. </p>
                <p class="mb-3">
                  I understand that the insurance Company’s willingness to provide coverage or reinstate coverage was
                  based on the understanding that there are no known unreported claims or incidents. I also understand that
                  all such unreported claims or incidents which later result in a claim will not be covered by the Company’s
                  policy.
                </p>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        v-model="rxApplication.nklName"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('name')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('name') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Title
                    </label>
                    <input
                        type="text"
                        name="title"
                        v-model="rxApplication.nklTitle"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('title')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('title') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Signature:
                    </label>
                    <input
                        type="text"
                        name="appSignature"
                        placeholder="Type Your Name to Sign"
                        class="orep-text-input w-100"
                        v-model="rxApplication.nklSignature"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                    <span
                        v-show="errors.has('appSignature')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('appSignature') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Date:
                    </label>
                    <input
                        type="date"
                        class="orep-text-input w-100 text-center"
                        :value="formattedCurrentDate()"
                        disabled
                    >
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <span v-if="rxApplication.customer.state == 'NY' || rxApplication.customer.state == 'CT' || rxApplication.customer.state == 'MA' || rxApplication.customer.state == 'AK'"
                        class="font-weight-bold">S APP 40008 04 22</span>
                  <span v-else
                        class="font-weight-bold">N APP 40008 09 23</span>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'rx-application-3'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('rx-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rx-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rx-application-3')"></button>
              <span class="pagination-dots pagination-current"></span>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('rx-application-5')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('rx-application-6')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('rx-application-7')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid|| !state.pageSixIsValid">
              </button>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="next('rx-application-5')"
              :disabled="!state.pageFourIsValid"
              :class="{submitDisabled: !state.pageFourIsValid}"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";

export default {
  name: "rx-application-4",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    rxApplication() {
      return this.$store.state.rxApplication.rxApplication;
    },
    state() {
      return this.$store.state.rxApplication;
    },
    errorMsg() {
      return this.$store.state.rxApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },

    next(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.rxApplication.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
    },
    CurrentDate() {
      return moment(this.rxApplication.applicantPrincipleEsignatureDatetime).format('MM/DD/YYYY');
    },

  },


  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
    }, 500);
  },

  components: {}
};
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
</style>

